/**
 * Admin-only backend Sentry verification helpers.
 * No DSN, tokens, or PII in user-facing copy.
 */

export const ADMIN_SENTRY_VERIFICATION_CARD_TEST_ID = 'admin-sentry-verification-card';
export const ADMIN_SENTRY_VERIFICATION_BUTTON_TEST_ID = 'admin-sentry-verification-send';
export const ADMIN_SENTRY_VERIFICATION_RESULT_TEST_ID = 'admin-sentry-verification-result';

const FORBIDDEN_RESULT_TOKENS = ['dsn', 'bearer', 'jwt', 'token', 'password', 'secret'];

/**
 * Classify a successful API JSON body from POST /admin/ops/sentry-test.
 */
export function resolveSentryTestResult(data) {
  if (!data || typeof data !== 'object') {
    return { kind: 'unknown', messageKey: 'admin.sentry_verify_unknown' };
  }

  if (data.sent === true) {
    return { kind: 'success', messageKey: 'admin.sentry_verify_success' };
  }

  if (data.reason === 'test_events_disabled') {
    return { kind: 'gate_disabled', messageKey: 'admin.sentry_verify_gate_disabled' };
  }

  if (data.reason === 'sentry_disabled') {
    return { kind: 'sentry_disabled', messageKey: 'admin.sentry_verify_sentry_disabled' };
  }

  if (data.reason === 'capture_failed') {
    return { kind: 'capture_failed', messageKey: 'admin.sentry_verify_capture_failed' };
  }

  return { kind: 'unknown', messageKey: 'admin.sentry_verify_unknown' };
}

/**
 * Map HTTP error status to safe operator guidance.
 */
export function resolveSentryTestError(status) {
  if (status === 401) {
    return { kind: 'auth', messageKey: 'admin.sentry_verify_auth' };
  }
  if (status === 403) {
    return { kind: 'forbidden', messageKey: 'admin.sentry_verify_forbidden' };
  }
  return { kind: 'error', messageKey: 'admin.sentry_verify_error' };
}

/**
 * Ensure rendered result text does not leak sensitive tokens.
 */
export function isSafeSentryResultText(text) {
  const normalized = String(text || '').toLowerCase();
  return !FORBIDDEN_RESULT_TOKENS.some((token) => normalized.includes(token));
}

export function resultToneClass(kind) {
  switch (kind) {
    case 'success':
      return 'text-emerald-700 bg-emerald-50 border-emerald-200';
    case 'gate_disabled':
    case 'sentry_disabled':
      return 'text-amber-800 bg-amber-50 border-amber-200';
    case 'auth':
    case 'forbidden':
      return 'text-red-700 bg-red-50 border-red-200';
    default:
      return 'text-slate-700 bg-slate-50 border-slate-200';
  }
}
